import { isAxiosError } from 'axios';

type ApiErrorBody = {
  errors?: { message?: string }[];
  error?: string;
  // pnet-api's AllExceptionFilter shape ({ statusCode, message, code_error }).
  message?: string;
};

function messagesFromBody(data: unknown): string[] {
  if (!data || typeof data !== 'object') {
    return [];
  }

  const body = data as ApiErrorBody;
  if (Array.isArray(body.errors)) {
    return body.errors
      .map((item) => item?.message)
      .filter(
        (message): message is string =>
          typeof message === 'string' && message.length > 0
      );
  }

  if (typeof body.error === 'string' && body.error.length > 0) {
    return [body.error];
  }

  if (typeof body.message === 'string' && body.message.length > 0) {
    return [body.message];
  }

  return [];
}

export function extractApiErrorMessages(error: unknown): string[] {
  if (!isAxiosError(error)) {
    return [];
  }

  return messagesFromBody(error.response?.data);
}
